<template>
  <v-dialog v-model="openDialog" fullscreen>
    <v-card class="fullscreen-dialog">
      <v-container>
        <v-row class="payment-container" align="center" justify="center">
          <v-col cols="8 mb-15">

            <h1 v-if="isFullSending && isSendingSuccess" class="white--text mb-7 text-center">Fatura enviada com sucesso!</h1>

            <h1 v-else-if="isFullSending && !isSendingSuccess" class="white--text mb-7 text-center">Error ao tentar enviar, tente novamente!</h1>

            <h1 v-if="!isSending && !isFullSending" class="white--text mb-7 text-center">{{!isNewEmail ? 'Digite o seu e-mail cadastrado' : 'Digite o novo e-mail'}}</h1>

            <div v-if="!isSending" class="card text-center">
              <v-form 
                v-if="!isFullSending && !isSendingSuccess"  
                ref="form" 
                @submit.prevent="handleEmailSending"
                autocomplete="off"
              >

                 <v-text-field
                    v-show="!isNewEmail" 
                    class="input-field mb-12 input-email"
                    type="email" 
                    v-model="email"
                    @input="onInputChange"  
                    color="black"
                    autofocus
                    :disabled="disabledTextField"
                    :rules="[() => !!email || 'Este campo é obrigatório']" 
                    placeholder="seuemail@email.com.br" 
                    prepend-inner-icon="mdi-email" 
                    outlined
                    clearable
                  ></v-text-field>

                 <v-text-field
                  v-show="isNewEmail"  
                    class="input-field mb-12"
                    type="email"
                    v-model="email"
                    @input="onInputChange" 
                    color="black"
                    autofocus
                    :rules="[() => !!email || 'Este campo é obrigatório']" 
                    placeholder="email@gmail.com.br" 
                    prepend-inner-icon="mdi-email" 
                    outlined
                    clearable
                  ></v-text-field>


                <v-btn
                  class="py-6  payment-button" 
                  block 
                  color="primary"
                  type="submit"
                  @click.right="handleEmailSending"
                >
                  <img src="@/assets/ic-login.png" class="mr-2" alt=""> 
                  Confirmar
                  <template v-slot:loader>
                    <span>Carregando...</span>
                  </template>
                </v-btn>

                <v-btn
                  class="py-6 payment-button mt-6" 
                  block  
                  color="white"
                  @click="goBack" 
                  @click.right="goBack" 
                >
                   
                  <v-icon left light color="black" size="24" class="mr-2">mdi-arrow-left</v-icon>
                    Voltar
                </v-btn> 

                <div v-if="hasEmail">
                <v-divider class="my-10"></v-divider>

                  <v-btn
                    class="py-6 payment-button" 
                    block  
                    @click="handleNewEmail"
                    @click.right="handleNewEmail"
                    color="white"
                >
                    <img src="@/assets/ic-login_black.png" class="mr-2" alt="">
                    {{!isNewEmail ? 'Usar outro e-mail' : 'Usar e-mail cadastrado'}}
                </v-btn> 
                </div>

                </v-form>

                <div v-else-if="isFullSending && isSendingSuccess">
                  <v-icon left light color="#0CCCA6" size="120" class="pr-4">mdi-email-check-outline</v-icon>
                  <v-divider class="my-10"></v-divider>
                    <v-btn
                    class="py-6 payment-button" 
                    block  
                    @click="goBack"
                    @click.right="goBack"
                    color="primary"
                   >
                    <v-icon left light color="white" size="24" class="mr-2 icon-arrow">mdi-arrow-left</v-icon>
                      Voltar ao início
                    </v-btn>
                     <v-btn
                    class="py-6 mt-6 payment-button"
                    color="white"
                    block  
                    @click="userLogout"
                    @click.right="userLogout"
                   >
                    <v-icon left light color="black" size="25" class="mr-2">mdi-exit-to-app</v-icon>
                      Encerrar sessão
                    </v-btn>  
                </div>

                <div v-else-if="isFullSending && !isSendingSuccess">
                  <v-icon left light color="red" size="120" class="pr-4">mdi-email-outline</v-icon>
                  <v-divider class="my-10"></v-divider>
                    <v-btn
                    class="py-6 payment-button" 
                    block  
                    @click="goBack"
                    @click.right="goBack"
                    color="primary"
                   >
                    <v-icon left light color="white" size="24" class="mr-2">mdi-arrow-left</v-icon>
                      Voltar ao início
                    </v-btn>
                     <v-btn
                    class="py-6 mt-6 payment-button"
                    color="white"
                    block  
                    @click="userLogout"
                    @click.right="userLogout"
                   >
                    <v-icon left light color="black" size="25" class="mr-2">mdi-exit-to-app</v-icon>
                      Encerrar sessão
                    </v-btn>  
                </div>

                
            </div>

            <div v-else>
              <Loading text="Enviando..."/>
            </div>
    
          </v-col>
        </v-row>
      </v-container>
        
    </v-card>

    <SimpleKeyboard
      v-if="!isSending && !isFullSending"  
      @onChange="onChange"
      @onKeyPress="onKeyPress"
      :input="email" 
    />

  </v-dialog>
</template>

<script>

import SimpleKeyboard from '@/SimpleKeyboard'

import userStore from "@/store/user.store"
import invoicesStore from "@/store/invoices.store"
import closePageInvoices from "@/store/closePageInvoices.store"

import {signOut} from "@/controllers/user.controller"

import Loading from '@/components/Loading/Loading';

import {updateLog} from '@/controllers/user.controller'

import axios from 'axios';
import config from "@/config.js";
import {getDateAndMonth, getDateToPT} from "@/services/date.service"
export default {
    name: "PaymentDialog",
    components: {Loading, SimpleKeyboard},
    props: {
      openDialog: {
        type: Boolean,
        default: false
      },
      isSendingReceipt: {
        type: Boolean,
        default: false
      },
      receipt: {
        type: Object,
        required: false
      },
    },
    data () {
      return {
        email: '',
        hasEmail: false,
        isNewEmail: false,
        userEmail: '',
        disabledTextField: false,
        isSending: false,
        isFullSending: false,
        isSendingSuccess: false,
        transactionType: 'emailSending',
        handleSetTimeout: '',
        time: 240000
      }
    },
    methods: {
    onChange(input) {
      this.email = input;
    },
    onKeyPress() {
      // params button
      // console.log("button", button);
    },
    onInputChange(input) {
      this.email = input?.target.value;
    },
    handleSetTimeoutOutput () {
      clearTimeout(this.handleSetTimeout)
      signOut()
    },
    goBack () {
      clearTimeout(this.handleSetTimeout)

      this.isFullSending = false
      this.isSendingSuccess = false

      closePageInvoices.commit('setIsToClose')

      this.$emit('close', true)

    },
     userLogout () {
      clearTimeout(this.handleSetTimeout)

      signOut()
    },
    async handleEmailSending (e) {
      e.preventDefault()
      if (this.$refs.form.validate()) { 

        if (this.isSendingReceipt) {
          const {nome} = userStore.getters.user;

          try {
            clearTimeout(this.handleSetTimeout)

            this.isSending = true;
            
            // const testReceipt = {
            //     "receipt": {
            //     typeCard: this.receipt.typeCard,
            //     flagCard: this.receipt.flagCard,
            //     nameCard: this.receipt.nameCard,
            //     numberCard: this.receipt.numberCard,
            //     invoices: this.receipt.invoices,
            //     valueUp: this.receipt.valueUp,
            //   },
            //   "userEmail": this.email.trim(),
            //   "userName": nome
            // }

            // console.log(`sending_receipt: ${JSON.stringify(testReceipt)}`);

            await axios.post(`${config.urlApiTely}/sending_receipt`, {
              "receipt": {
                typeCard: this.receipt.typeCard,
                flagCard: this.receipt.flagCard,
                nameCard: this.receipt.nameCard,
                numberCard: this.receipt.numberCard,
                invoices: this.receipt.invoices,
                valueUp: this.receipt.valueUp,
              },
              "userEmail": this.email.trim(),
              "userName": nome
            })

            this.isSending = false;
            this.isFullSending = true
            this.isSendingSuccess = true
            
            return
          } catch (error) {
            this.isSending = false;
            this.isFullSending = true;
            this.isSendingSuccess = false;
            return
          }
         
        }


      clearTimeout(this.handleSetTimeout)

      this.isSending = true;
     
      const invoices = invoicesStore.getters.invoices
     
      const {codigo, nome} = userStore.getters.user

      const userName = nome.split(' ')[0]

      

      try {
        for (const invoice of invoices) {
          const payload = {
          "send_banking_billet":
            {
              "document_id": invoice.id,
              "customer_id": codigo,
              "customer_email": this.email.trim(),
              "email_subject": `Sua fatura TELY por e-mail - ${getDateAndMonth(invoice.due_date)}.`,
              "email_body": `Olá ${userName}, você está recebendo em anexo a sua fatura Tely com vencimento no dia ${getDateToPT(invoice.due_date)}.`
            }
          }

          console.log(`send_banking_billet: ${JSON.stringify(payload)}`);
        
          await axios.post(`${config.urlApiTely}/send_banking_billet`, payload)
        }

        updateLog('emailTransaction')

        this.isSending = false;
        this.isFullSending = true
        this.isSendingSuccess = true

        if (this.isFullSending) {
          this.handleSetTimeout = setTimeout(this.handleSetTimeoutOutput, this.time);
        }
 
      } catch (error) {
        console.log(error)

        this.isSending = false;
        this.isFullSending = true
        this.isSendingSuccess = false
      }
    }
    },
    handleNewEmail () {
      if (!this.isNewEmail) {
        this.isNewEmail = true
        this.disabledTextField = false
        this.email = '';
      } else {
        this.isNewEmail = false
        this.disabledTextField = true
        this.email = this.userEmail;
      }
    }
  },
  mounted () {
    this.handleSetTimeout = setTimeout(this.handleSetTimeoutOutput, this.time);
  },
    beforeMount() {
    const {email} = userStore.getters.user

    this.userEmail = email

    if (this.userEmail) {
      this.email = this.userEmail;
      this.disabledTextField = true
      this.hasEmail = true
    }
  } 
}
</script>

<style scoped>
::v-deep .v-text-field__slot  {
  height: 66px;
  font-size: 21px;
  font-weight: bold;
}

::v-deep .v-input__icon {
  align-self: center;
  font-size: 21px;
  margin-top: 5px;
}
::v-deep .v-messages__message  {
  font-size: 16px;
}

.fullscreen-dialog .payment-container {
    height: 100vh;
    
}

.fullscreen-dialog .payment-button {
    box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.4), 0px 6px 16px rgba(35, 41, 46, 0.2) !important;
    border-radius: 16px !important;
    font-weight: 600 !important;
    font-size: 17px !important;
}

h1 {
    font-size: 26px;
    font-weight: 600;
    line-height: 32.76px;
    letter-spacing: 0.15px;
}

.white--text{
    color: #1A237E !important;
}

.icon-arrow {
  color: white !important;
}

</style>

